var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamesRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 128,
    viewBox: "0 0 193 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1898 86.2799L29.9799 77.6299L25.5898 87.3299L36.1898 86.2799Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89033 83.4302C5.46033 83.4302 5.04028 83.2702 4.71028 82.9402L1.66035 79.8902C1.01035 79.2402 1.01035 78.1902 1.66035 77.5402C2.31035 76.8902 3.36033 76.8902 4.01033 77.5402L7.06038 80.5902C7.71038 81.2402 7.71038 82.2902 7.06038 82.9402C6.74038 83.2702 6.31033 83.4302 5.89033 83.4302Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2799 103.39L6.62988 118.19",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.92 80.8498C128.76 80.8498 130.36 82.1398 130.74 83.9398L132.54 92.3998C134.12 99.7998 141.6 105.85 149.17 105.85C156.74 105.85 161.64 99.7998 160.06 92.3998L150.06 45.4898C148.51 38.2198 141.36 33.5898 134.1 35.1398C132.07 35.5698 130.26 36.4498 128.72 37.6398H73.95C73.93 37.6298 73.9201 37.6198 73.9001 37.5998C71.0301 35.4098 67.2801 34.6998 63.7501 35.4898C59.5501 36.4298 53.83 39.4298 51.94 48.5898L43.21 89.5098C41.7 96.5998 45.8401 103.85 52.8501 105.7C60.3301 107.67 67.85 102.98 69.45 95.4998L71.9101 83.9398C72.2901 82.1398 73.8901 80.8498 75.7301 80.8498H76.94",
    fill: "#AE3EC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.911 58.8598H84.9604C82.6504 58.8598 80.7705 56.9898 80.7705 54.6698V37.7598H122.09V54.6698C122.1 56.9798 120.231 58.8598 117.911 58.8598Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.01 68.8293C146.123 68.8293 151.89 63.0628 151.89 55.9493C151.89 48.8359 146.123 43.0693 139.01 43.0693C131.896 43.0693 126.13 48.8359 126.13 55.9493C126.13 63.0628 131.896 68.8293 139.01 68.8293Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7804 68.8293C70.8938 68.8293 76.6604 63.0628 76.6604 55.9493C76.6604 48.8359 70.8938 43.0693 63.7804 43.0693C56.667 43.0693 50.9004 48.8359 50.9004 55.9493C50.9004 63.0628 56.667 68.8293 63.7804 68.8293Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.13 83.3401C90.5531 83.3401 95.76 78.1331 95.76 71.7101C95.76 65.287 90.5531 60.0801 84.13 60.0801C77.7069 60.0801 72.5 65.287 72.5 71.7101C72.5 78.1331 77.7069 83.3401 84.13 83.3401Z",
    fill: "#862E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7103 80.8493C89.4486 80.8493 94.1003 76.1976 94.1003 70.4593C94.1003 64.7211 89.4486 60.0693 83.7103 60.0693C77.9721 60.0693 73.3203 64.7211 73.3203 70.4593C73.3203 76.1976 77.9721 80.8493 83.7103 80.8493Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4298 67.55C72.5432 67.55 78.3098 61.7835 78.3098 54.67C78.3098 47.5566 72.5432 41.79 65.4298 41.79C58.3164 41.79 52.5498 47.5566 52.5498 54.67C52.5498 61.7835 58.3164 67.55 65.4298 67.55Z",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.73 67.55C144.843 67.55 150.61 61.7835 150.61 54.67C150.61 47.5566 144.843 41.79 137.73 41.79C130.616 41.79 124.85 47.5566 124.85 54.67C124.85 61.7835 130.616 67.55 137.73 67.55Z",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.25 57.7796C148.083 57.7796 149.57 56.2932 149.57 54.4596C149.57 52.6261 148.083 51.1396 146.25 51.1396C144.416 51.1396 142.93 52.6261 142.93 54.4596C142.93 56.2932 144.416 57.7796 146.25 57.7796Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.25 56.0501C147.128 56.0501 147.84 55.3383 147.84 54.4601C147.84 53.582 147.128 52.8701 146.25 52.8701C145.372 52.8701 144.66 53.582 144.66 54.4601C144.66 55.3383 145.372 56.0501 146.25 56.0501Z",
    stroke: "#BE4BDB",
    strokeWidth: 0.9781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.87 83.3401C126.293 83.3401 131.5 78.1331 131.5 71.7101C131.5 65.287 126.293 60.0801 119.87 60.0801C113.447 60.0801 108.24 65.287 108.24 71.7101C108.24 78.1331 113.447 83.3401 119.87 83.3401Z",
    fill: "#862E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.281 80.8493C126.019 80.8493 130.671 76.1976 130.671 70.4593C130.671 64.7211 126.019 60.0693 120.281 60.0693C114.542 60.0693 109.891 64.7211 109.891 70.4593C109.891 76.1976 114.542 80.8493 120.281 80.8493Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07 78.5695C124.433 78.5695 127.97 75.0326 127.97 70.6695C127.97 66.3065 124.433 62.7695 120.07 62.7695C115.707 62.7695 112.17 66.3065 112.17 70.6695C112.17 75.0326 115.707 78.5695 120.07 78.5695Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07 75.2396C122.594 75.2396 124.64 73.1936 124.64 70.6696C124.64 68.1457 122.594 66.0996 120.07 66.0996C117.546 66.0996 115.5 68.1457 115.5 70.6696C115.5 73.1936 117.546 75.2396 120.07 75.2396Z",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7104 78.3596C88.0735 78.3596 91.6105 74.8226 91.6105 70.4596C91.6105 66.0965 88.0735 62.5596 83.7104 62.5596C79.3474 62.5596 75.8105 66.0965 75.8105 70.4596C75.8105 74.8226 79.3474 78.3596 83.7104 78.3596Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7106 75.0296C86.2345 75.0296 88.2806 72.9836 88.2806 70.4596C88.2806 67.9357 86.2345 65.8896 83.7106 65.8896C81.1866 65.8896 79.1406 67.9357 79.1406 70.4596C79.1406 72.9836 81.1866 75.0296 83.7106 75.0296Z",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6002 46.3598H77.2002C76.6702 46.3598 76.2402 45.9298 76.2402 45.3998V41.5098C76.2402 40.9798 76.6702 40.5498 77.2002 40.5498H78.6002C79.1302 40.5498 79.5603 40.9798 79.5603 41.5098V45.3998C79.5603 45.9298 79.1302 46.3598 78.6002 46.3598Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.97 46.3598H124.57C124.04 46.3598 123.61 45.9298 123.61 45.3998V41.5098C123.61 40.9798 124.04 40.5498 124.57 40.5498H125.97C126.5 40.5498 126.93 40.9798 126.93 41.5098V45.3998C126.93 45.9298 126.5 46.3598 125.97 46.3598Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.93 57.5797H86.2397C83.9297 57.5797 82.0498 55.7096 82.0498 53.3896V37.6396H121.11V53.3997C121.11 55.7097 119.24 57.5797 116.93 57.5797Z",
    fill: "#E599F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.22 57.7796C131.054 57.7796 132.54 56.2932 132.54 54.4596C132.54 52.6261 131.054 51.1396 129.22 51.1396C127.387 51.1396 125.9 52.6261 125.9 54.4596C125.9 56.2932 127.387 57.7796 129.22 57.7796Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.68 53H127.75V55.93H130.68V53Z",
    stroke: "#BE4BDB",
    strokeWidth: 1.1248,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.98 50.0599C139.814 50.0599 141.3 48.5735 141.3 46.7399C141.3 44.9063 139.814 43.4199 137.98 43.4199C136.147 43.4199 134.66 44.9063 134.66 46.7399C134.66 48.5735 136.147 50.0599 137.98 50.0599Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.98 47.4195H135.99L136.99 46.2195L137.98 45.0195L138.98 46.2195L139.98 47.4195H137.98Z",
    stroke: "#BE4BDB",
    strokeWidth: 1.0626,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.63 66.6097C139.464 66.6097 140.95 65.1233 140.95 63.2897C140.95 61.4561 139.464 59.9697 137.63 59.9697C135.797 59.9697 134.311 61.4561 134.311 63.2897C134.311 65.1233 135.797 66.6097 137.63 66.6097Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.36 62.0195L138.91 64.5695",
    stroke: "#BE4BDB",
    strokeWidth: 0.8694,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.91 62.0195L136.36 64.5695",
    stroke: "#BE4BDB",
    strokeWidth: 0.8694,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3102 52.3902H67.5502V47.6302C67.5502 46.8202 66.8901 46.1602 66.0801 46.1602H64.0302C63.2202 46.1602 62.5602 46.8202 62.5602 47.6302V52.3902H57.8002C56.9902 52.3902 56.3301 53.0502 56.3301 53.8602V55.9102C56.3301 56.7202 56.9902 57.3802 57.8002 57.3802H62.5602V62.1402C62.5602 62.9502 63.2202 63.6102 64.0302 63.6102H66.0801C66.8901 63.6102 67.5502 62.9502 67.5502 62.1402V57.3802H72.3102C73.1202 57.3802 73.7802 56.7202 73.7802 55.9102V53.8602C73.7802 53.0402 73.1302 52.3902 72.3102 52.3902Z",
    fill: "#9C36B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0597 56.75H67.2596L66.1597 58L65.0597 59.24L63.9596 58L62.8496 56.75H65.0597Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0597 52.5896H62.8496L63.9596 51.3496L65.0597 50.0996L66.1597 51.3496L67.2596 52.5896H65.0597Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5098 54.6697V52.4697L68.7598 53.5697L69.9998 54.6697L68.7598 55.7697L67.5098 56.8697V54.6697Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5203 54.6697V56.8697L61.2803 55.7697L60.0303 54.6697L61.2803 53.5697L62.5203 52.4697V54.6697Z",
    fill: "#BE4BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.09 0.879883C166.09 0.879883 180.121 12.3599 168.641 20.0099C157.161 27.6599 126.561 11.0799 109.041 20.0099C93.3506 27.9999 100.84 37.6399 100.84 37.6399",
    stroke: "#BE4BDB",
    strokeWidth: 1.2751,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.95 81.8201L173.78 74.6201L170.13 82.6901L178.95 81.8201Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.11 13.31C187.8 13.31 187.49 13.19 187.25 12.95C186.78 12.48 186.78 11.71 187.25 11.23L189.48 8.99996C189.95 8.52996 190.72 8.52996 191.2 8.99996C191.67 9.46996 191.67 10.24 191.2 10.72L188.97 12.95C188.73 13.2 188.42 13.31 188.11 13.31Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.79 122.72C176.055 122.72 177.08 121.694 177.08 120.43C177.08 119.165 176.055 118.14 174.79 118.14C173.525 118.14 172.5 119.165 172.5 120.43C172.5 121.694 173.525 122.72 174.79 122.72Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.79 37.1504L162.92 47.7804",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5 47.5498L158.77 59.0998",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.61 124.61L148.37 110.74",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.37 11.3396L147.21 4.13965L143.561 12.2096L152.37 11.3396Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.03 10.31C118.72 10.31 118.41 10.19 118.17 9.94996C117.7 9.47996 117.7 8.70996 118.17 8.22996L120.4 5.99996C120.87 5.52996 121.64 5.52996 122.12 5.99996C122.59 6.46996 122.59 7.23996 122.12 7.71996L119.89 9.94996C119.65 10.2 119.34 10.31 119.03 10.31Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3789 11.5231L36.5986 10.042L35.1176 13.8222L38.8978 15.3033L40.3789 11.5231Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1799 5.9502L53.6299 25.5902",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7604 7.11035L68.6504 20.9704",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3301 41.7805C14.3301 41.7805 29.0301 50.3605 41.5801 34.7305",
    stroke: "#DA77F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5598 37.3201L41.3597 34.9301L38.9697 35.1401L39.8898 34.0401L42.2798 33.8301L42.4897 36.2201L41.5598 37.3201Z",
    fill: "#DA77F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6 123.2C112.879 123.2 118.78 117.299 118.78 110.02C118.78 102.741 112.879 96.8398 105.6 96.8398C98.3207 96.8398 92.4199 102.741 92.4199 110.02C92.4199 117.299 98.3207 123.2 105.6 123.2Z",
    fill: "#AE3EC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.28 121.49C113.559 121.49 119.46 115.589 119.46 108.31C119.46 101.031 113.559 95.1299 106.28 95.1299C99.0006 95.1299 93.0996 101.031 93.0996 108.31C93.0996 115.589 99.0006 121.49 106.28 121.49Z",
    fill: "#E599F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.65 111.45C105.49 114.13 110.77 113.19 113.45 109.34",
    stroke: "#BE4BDB",
    strokeWidth: 1.0677,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5303 99.9707L100.33 102.171L103.72 101.121L102.49 104.461L104.54 107.361L100.99 107.221L98.8602 110.071L97.9003 106.651L94.5303 105.501L97.4902 103.531L97.5303 99.9707Z",
    fill: "#AE3EC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.439 98.9102L109.939 98.2402L111.359 94.9902L113.079 98.1002L116.62 98.4502L114.189 101.05L114.949 104.52L111.729 103.01L108.66 104.81L109.099 101.28L106.439 98.9102Z",
    fill: "#AE3EC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8295 124.4L54.7595 120.82L54.1895 127L59.8295 124.4Z",
    stroke: "#DA77F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesRightImage);
export default __webpack_public_path__ + "static/media/gamesRightImage.2fdccf93255ead5a19785d4c412f5b18.svg";
export { ForwardRef as ReactComponent };